import loading from '../../components/common/loading'

const load = {};
var interval = null;
load.install = function (Vue) {
  const LoadingC = Vue.extend(loading);
  const instance = new LoadingC();
  instance.$mount(document.createElement('div'));
  document.body.appendChild(instance.$el);
  Vue.prototype.$loadingshow = () => {
    instance.visible = true;
    interval = setTimeout(function () {
      // alert('网络异常');
      instance.visible = false
    }, 1000 * 60)
  };
  Vue.prototype.$loadingclose = () => {
    clearTimeout(interval);
    instance.visible = false
  }
};
export default load



// WEBPACK FOOTER //
// ./src/assets/js/loading.js